
function computeBestAcceleration(data, startSpeed, endSpeed) {
    let bestTime = Infinity;  // Initialize with a very large number for comparison

    for (let i = 0; i < data.length - 1; i++) {
        if (data[i].speed <= startSpeed && data[i + 1].speed > startSpeed) {  // Crossing startSpeed
            for (let j = i + 1; j < data.length; j++) {
                if (data[j].speed >= endSpeed) {  // Crossing endSpeed
                    let timeDifference = data[j].date - data[i].date;

                    // Check if this acceleration time is better than the previous best
                    if (timeDifference < bestTime) {
                        bestTime = timeDifference;
                    }
                    break;  // Move to the next startSpeed crossing
                }
            }
        }
    }

    // Convert the best time from milliseconds to seconds
    let bestTimeSeconds = bestTime / 1000;

    return bestTimeSeconds;
}

export function getBestTimeStr(data, startSpeed, endSpeed) {
    let bestTime = computeBestAcceleration(data, startSpeed, endSpeed);
    if (bestTime === Infinity) {
        return "N/A";
    } else {
        return bestTime.toFixed(1) + " s";
    }
}
